import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Sms.Data.CaseloadData[]> {
  return axios.get(route('api.sms.caseloads.search', filters)).then((res) => res.data);
}
